import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { TranslationEntries } from '@service-initiation/tech-care-data-access-i18n';
import {
  DeliveryMethod,
  useDeliveryMethodValue,
} from '@service-initiation/tech-care-data-access-store';

import { SectionContainer, SectionList, SectionTitle } from '../components';
import { AppointmentTimeSummaryItem } from './AppointmentTimeSummaryItem';
import { CustomerDetailsSummaryItem } from './CustomerDetailsSummaryItem';
import { LocationSummaryItem } from './LocationSummaryItem';
import { PaymentMethodSummaryItem } from './PaymentMethodSummaryItem';

const TEXT = TranslationEntries.Repairs.Cart.VisitDetails;

export const VisitDetailsSection = () => {
  const { t } = useTranslation();
  const deliveryMethod = useDeliveryMethodValue();

  const deliveryMethodDetailsConfig = useMemo(
    () => ({
      ComeToMe: [
        <LocationSummaryItem key="come-to-me-location-summary-item" />,
        <AppointmentTimeSummaryItem key="come-to-me-appointment-summary-item" />,
        <CustomerDetailsSummaryItem key="come-to-me-customer-details-summary-item" />,
        <PaymentMethodSummaryItem key="come-to-me-payment-method-summary-item" />,
      ],
      MailIn: [
        <LocationSummaryItem key="mail-in-location-summary-item" />,
        <CustomerDetailsSummaryItem key="mail-in-customer-details-summary-item" />,
      ],
      VisitStore: [
        <LocationSummaryItem key="visit-store-location-summary-item" />,
        <AppointmentTimeSummaryItem key="visit-store-appointment-time-summary-item" />,
        <CustomerDetailsSummaryItem key="visit-store-customer-details-summary-item" />,
      ],
    }),
    []
  );

  return (
    <SectionContainer skeletonHeight="175px">
      <SectionTitle>
        {deliveryMethod === DeliveryMethod.MailIn
          ? t(TEXT.MailInTitle)
          : t(TEXT.Title)}
      </SectionTitle>
      <SectionList>
        {deliveryMethodDetailsConfig[
          deliveryMethod || DeliveryMethod.VisitStore
        ]?.map((summaryItem) => summaryItem)}
      </SectionList>
    </SectionContainer>
  );
};
